<template>
  <div>
    <div
      v-if="avatar && !showDropzone"
      class="flex justify-center mb-4"
    >
      <img
        :src="avatar"
        alt=""
        class="rounded-full w-32 h-32"
      >
    </div>
    <BaseDropzone
      v-show="showDropzone"
      id="dropzone"
      ref="userAvatarUpload"
      inline-previews
      :options="dropzoneOptions"
      :class="{ 'mb-2': showDropzone }"
      @dropzone-file-added="filesHaveBeenAdded"
      @dropzone-success="fileHasBeenUploaded"
    />
    <div class="flex justify-center">
      <button
        type="button"
        class="btn btn--border"
        :class="{
          load: isUploading || isRemovingAvatar,
          'btn--danger': !isUploading && !isRemovingAvatar && showDropzone
        }"
        @click="changePhoto"
        v-text="avatarButtonMessage"
      />
    </div>
    <div class="flex justify-center mt-4 text-xs">
      <button
        type="button"
        @click.stop.prevent="removePhoto"
        v-text="'Remove image and use my initials instead'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'UserAvatar',
  props: {
    avatar: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isUploading: false,
      isRemovingAvatar: false,
      dropzoneOptions: {
        url: this.$urlGenerator.public('api/v1/me/avatar'),
        maxFiles: 1,
        addRemoveLinks: false,
        autoProcessQueue: true,
        acceptedFiles: 'image/*',
        dictDefaultMessage: 'Click or drag files here to change photo...',
      },
      showDropzone: false,
    }
  },
  computed: {
    avatarButtonMessage() {
      if (this.isUploading && !this.isRemovingAvatar) {
        return 'Uploading...'
      }

      if (!this.isUploading && this.isRemovingAvatar) {
        return 'Removing avatar...'
      }

      if (this.showDropzone) {
        return 'Cancel Avatar Change'
      }

      return 'Change your avatar'
    },
  },
  methods: {
    changePhoto() {
      if (this.isUploading) {
        return
      }

      this.showDropzone = !this.showDropzone
    },
    removePhoto() {
      this.isRemovingAvatar = true

      this.$api.public()
        .delete('/me/avatar')
        .then(({ data }) => {
          this.isRemovingAvatar = false

          this.$emit('avatarUploaded', data.attributes.avatar.small)
        })
    },
    fileHasBeenUploaded(file) {
      file = JSON.parse(file.xhr.response)

      this.$emit('avatarUploaded', file.attributes.avatar.small)

      this.isUploading = false
      this.showDropzone = false

      this.$refs.userAvatarUpload.removeAllFiles()
    },
    filesHaveBeenAdded() {
      this.isUploading = true
    },
  },
}
</script>
